import React, { Component } from "react";
import { getApplication } from "../../utils/commons";

class Breadcrumb extends Component {
	render() {
		const application = getApplication();
		return (
			<div
				className="subheader dark-overlay dark-overlay-2"
				style={{
					backgroundImage:
						"url(" +
						process.env.REACT_APP_PUBLIC_URL +
						application.banniere +
						"",
				}}
			>
				<div className="container">
					<div>
						<img
							alt="Logo"
							src={process.env.REACT_APP_PUBLIC_URL + application.logo}
							style={{ width: "20%" }}
						/>
					</div>
					<div className="subheader-inner">
						{/* <h1>{this.props.breadcrumb.pagename}</h1> */}
						{/* {!!application.title && <h1>{application.title}</h1>} */}
						<nav aria-label="breadcrumb">
							<ol className="breadcrumb">
								{/* <li className="breadcrumb-item"><Link to="/">Home</Link></li> */}
								<li className="breadcrumb-item active" aria-current="page">
									{this.props.breadcrumb.subtitle}
								</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
		);
	}
}

export default Breadcrumb;
